const Joi = require("joi");

const registeredUserNotesSchema = (data) => {
  const schema = Joi.object({
    notes: Joi.string()
      .trim()
      .required() // Mark the field as required
      .messages({
        "any.required": "Please enter Notes.",
        "string.empty": "Please enter Notes.", // Custom message for empty string
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = registeredUserNotesSchema;
